
<div class="menu-div">
  <h4 class="header">Upload Event QR Code</h4>
  <mat-divider></mat-divider>
  <div class="alert alert-info" *ngIf="showMessage !== ''">{{ showMessage }}</div>

  <form [formGroup]="formGroup" class="qr-code-form">
    <div class="toggle-container">
      <mat-slide-toggle formControlName="showQRCode" (change)="textChange($event)" class="slide-toggle">
        Show QR Code
      </mat-slide-toggle>
    </div>

    <div *ngIf="formGroup.controls['showQRCode'].value">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Text Above QR Code (maximum 30 characters)</mat-label>
        <input matInput formControlName="textAboveQRCode" placeholder="Enter text" maxlength="30"
          (input)="textChange(null)">
      </mat-form-field>
    </div>
    <div class="overlay" *ngIf="isSavingData">
      <!-- <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div> -->
        <span class="loader"></span>
    </div>
    <div *ngIf="formGroup.controls['showQRCode'].value">
      <div class="image-upload-section">
        <h3 *ngIf="default_qrcode" class="text-center">Default QR Code</h3>
        <div class="image-preview-container">
          <img *ngIf="imageSrc" [src]="imageSrc" class="preview" alt="Image Preview">
        </div>
     
          <div class="file-upload-container">
            <label for="file-upload" class="file-upload-label">
              <span class="upload-text">Select</span>
            </label>
            <input id="file-upload" (change)="onFileSelected($event)" type="file" accept=".png, .jpg, .jpeg, .webp" class="file-upload-input">

            <button mat-raised-button *ngIf="!default_qrcode" class="remove-button" (click)="removeImage()">Remove</button> 

            <button mat-raised-button class="btn btn-upload" style="margin-left: 10px;" *ngIf="formGroup.controls['showQRCode'].value" [disabled]="formGroup.invalid || isbtnDisabled"
            (click)="uploadImage()">Save</button>
          </div>
         
        <div *ngIf="fileTypeError" class="error-message">
          Only PNG, JPG, and WEBP files are allowed.
        </div>
      </div>
    </div>

    <!-- <div class="button-container" *ngIf="formGroup.controls['showQRCode'].value">
      <button mat-raised-button class="btn btn-upload" [disabled]="formGroup.invalid || isbtnDisabled"
        (click)="uploadImage()">Save</button>
    </div> -->
  </form>
</div>